/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespBreadcrumbs_item = {
    readonly breadcrumbs: ReadonlyArray<{
        readonly key: string | null;
        readonly path: string | null;
        readonly displayName: string | null;
    } | null> | null;
    readonly " $refType": "PdpRespBreadcrumbs_item";
};
export type PdpRespBreadcrumbs_item$data = PdpRespBreadcrumbs_item;
export type PdpRespBreadcrumbs_item$key = {
    readonly " $data"?: PdpRespBreadcrumbs_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespBreadcrumbs_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespBreadcrumbs_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemBreadcrumb",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'c5fe69e64671b268ee9fb155ac9eedac';
export default node;
